import { FormField } from '@framework/form/field/FormField.tsx';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { type SizeType } from 'antd/es/config-provider/SizeContext';
import { useMemo } from 'react';
import { type FieldDatatype } from '../../../datatype/Datatype.ts';
import { OperatorsRepository } from '../../../repository/operators/OperatorsRepository.ts';
import { type IBaseConditionOperatorType } from '../IConditionOperator.ts';

export interface IConditionOperatorInputProps {
  /** Il tipo di dato per cui mostrare gli operatori */
  field: FieldDatatype;
  name: string;
  onOperatorChange?: (operator: IBaseConditionOperatorType) => void;
  size?: SizeType;
}

export function ConditionOperatorInput(props: IConditionOperatorInputProps) {
  const options = useMemo(
    () =>
      OperatorsRepository.forField(props.field).map(type => ({
        label: type.label,
        description: type.description + ' ' + type.label,
        value: type.code,
        operator: type,
      })),
    [props.field],
  );

  return (
    <div>
      <FormField
        noStyle
        size={props.size ?? 'middle'}
        component={SelectInput}
        name={props.name}
        style={{ width: 'auto' }}
        placeholder="Operatore..."
        popupMatchSelectWidth={false}
        showSearch
        optionFilterProp="description"
        options={options}
        onChange={(value, option, onChange) => {
          const operator = (option as any)?.operator;
          onChange(value);
          props.onOperatorChange?.(operator);
        }}
      />
    </div>
  );
}
